<template>
    <div>
        <b-button variant="primary" @click="openModalCamera" v-if="!providerItem">
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="text-nowrap text-capitalize">
                {{ $t("match_rules.assign_camera") }}
            </span>
        </b-button>

        <b-modal v-model="showModalCamera" :title="$t('match_rules.assign_camera')" @hide="resetForm" hide-footer
            no-close-on-backdrop size="lg">
            <b-form @submit.prevent="saveItem">
                <validation-observer ref="refFormObserver">

                    <validation-provider #default="validationContext" :name="$t('match_rules.camera')" rules="required">
                        <b-form-group :label="$t('match_rules.main_camera')">
                            <vSelectCamera v-model="formCamera.value" :selected.sync="formCamera.value" :ids_tenant="tenantIds"/>
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                    <validation-provider #default="validationContext" :name="$t('match_rules.action')" rules="required">
                        <b-form-group :label="$t('match_rules.action')">
                            <v-select :options="actionOptions" v-model="formCamera.action" class="w-100"
                                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" :reduce="val => val.value" />
                            <b-form-invalid-feedback :state="getValidationState(validationContext)">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </validation-provider>

                </validation-observer>
                <div class="d-flex justify-content-end mt-3">
                    <b-button variant="primary" class="mr-2" @click="closeModalCamera">
                        {{ $t("actions.cancel") }}
                    </b-button>
                    <b-button type="submit" variant="success">
                        {{ $t("actions.save") }}
                    </b-button>
                </div>

            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { ref, watch, computed, onMounted, getCurrentInstance, reactive } from "@vue/composition-api";
import vSelect from "vue-select";
import store from "@/store";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import formValidation from "@core/comp-functions/forms/form-validation";
import vSelectCamera from "./vSelectCamera.vue";


export default {
    components: {
        vSelect,
        ValidationProvider,
        ValidationObserver,
        vSelectCamera
    },
    props: {
        editItem: Object,
        providerItem: Object,
        tenantIds: Array,
    },
    setup(props, { emit }) {
        // form validation component
        const { proxy } = getCurrentInstance();
        const { refFormObserver, getValidationState } = formValidation();

        const showModalCamera = ref(false);

        // formCamera for modal camera
        const formCamera = reactive({
            action: '',
            field: 'camera',
            valueType: 'int',
            value: [],
        });

        // Retrieves the list of actions from Vuex
        const actionOptions = computed(() => {
            return store.getters["alarm_action/getProviderItems"].map(option => ({
                label: proxy.$t(`match_rules_action.${option.description}`),
                value: option.description,
            }));
        })

        // Retrieves the list of cameras from Vuex
        const cameraOptions = computed(() => {
            return store.getters["cm_camera/getSelectedItems"].map(option => ({
                value: option.value,
                label: option.label,
            }));
        });

        // Fetches alarm actions and filter providers when the component is mounted
        onMounted(() => {
            store.dispatch("alarm_action/getAll");
            store.dispatch("alarm_filter_types/getProviders");
        });

        // Watches for changes to the item being edited and opens the camera modal if its a camera rule
        watch(() => props.editItem, (newItem) => {
            // conditional saving
            if (newItem && newItem.field === 'camera') {
                formCamera.action = newItem.action;
                formCamera.field = newItem.field;
                formCamera.valueType = newItem.valueType;
                formCamera.value = [...newItem.value];
                showModalCamera.value = true
            }
        });

        const openModalCamera = () => {
            resetForm();
            showModalCamera.value = true;
        };

        const closeModalCamera = () => {
            resetForm();
            showModalCamera.value = false;
        };

        const saveItem = async () => {
            const validation = await refFormObserver.value.validate();
            if (!validation) return;

            if (showModalCamera.value) {
                emit("save", { ...formCamera });
                closeModalCamera();
                return;
            }

            closeModalCamera();
        };

        const resetForm = () => {
            formCamera.action = '';
            formCamera.field = 'camera';
            formCamera.valueType = 'int';
            formCamera.value = [];
        };

        return {
            saveItem,
            resetForm,
            formCamera,
            refFormObserver,
            getValidationState,
            showModalCamera,
            openModalCamera,
            closeModalCamera,
            actionOptions,
            cameraOptions,
        };
    }

};
</script>